module.exports = __webpack_public_path__ + "static/vwhead-regularitalic-a2abff22b25c6659eeb6baed13b1fd65.woff2";